import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const fetchEvents = (params = {}) => api.get("/events", { params }).then((r) => r.data);
export const fetchEvent = (slug) => api.get(`/events/${slug}`).then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);
export const subscribe = (email, source = "popup") => api.post("/subscribe", { email, source }).then((r) => r.data);
export const seed = () => api.post("/seed").then((r) => r.data);
